module.exports = __webpack_public_path__ + "ce3241443b848f3e419f2a4ae2e638de.pdf";